export const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
export const MAX_CENTS = 10000000;
export const DEFAULT_PROCESSING_FEES = { card: { percentage: '4', fixed: '0.30' }, international: { percentage: '4.5', fixed: '0.30' }, affirm: { percentage: '6', fixed: '0.30' } };
export function parseCents(value, allowZero = false) {
    const text = String(value).trim();
    if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
    const [whole, fraction = ''] = text.split('.');
    const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    return Number.isSafeInteger(cents) && cents >= (allowZero ? 0 : 1) && cents <= MAX_CENTS ? cents : null;
}
export function calculateFees(baseText, percentageText, fixedText) {
    const base = parseCents(baseText), fixed = parseCents(fixedText, true);
    const percentage = String(percentageText).trim();
    if (base === null || fixed === null || !/^\d+(\.\d{1,2})?$/.test(percentage) || Number(percentage) >= 100) return null;
    const bps = Math.round(Number(percentage) * 100);
    const fee = charge => Math.round(charge * bps / 10000) + fixed;
    const percentageFee = Math.round(base * bps / 10000);
    const total = base + percentageFee + fixed;
    let required = Math.ceil((base + fixed) * 10000 / (10000 - bps));
    while (required - fee(required) < base) required++;
    while (required > 0 && required - 1 - fee(required - 1) >= base) required--;
    return { base, fixed, percentageFee, total, net: total - fee(total), required, requiredNet: required - fee(required) };
}
export function requestId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const h = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
